<template>
    <v-card class="elevation-10 px-5 pt-3 pb-1">
        <!-- form header -->
        <v-card-title>
            <div class="layout column align-center">
                <h2 class="form__title">Авторизация</h2>
                <div class="form__subtitle text-xs-center">
                    данные для входа находятся в приложении к вашему договору
                </div>
            </div>
        </v-card-title>

        <!-- form -->
        <v-form ref="signinForm" lazy-validation>
            <!-- login field -->
            <v-text-field
                label="Номер телефона"
                mask="phone"
                prefix="+7"
                placeholder="(000) 000 - 0000"
                color="indigo_6"
                v-model="signinLogin"
                :rules="[rules.required]"
                validate-on-blur
                outline
                required
            ></v-text-field>

            <!-- password field -->
            <v-text-field
                label="Пароль"
                color="indigo_6"
                v-model="signinPassword"
                :rules="[rules.required]"
                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                :type="showPassword ? 'text' : 'password'"
                outline
                required
                validate-on-blur
                @click:append="showPassword = !showPassword"
                @keyup.enter="validate"
            ></v-text-field>

            <!-- form button -->
            <div class="layout column align-center">
                <v-btn class="btn" color="indigo_5" large dark @click="validate"
                    >Войти</v-btn
                >
            </div>
        </v-form>

        <!-- form links block  -->
        <v-card-text>
            <div class="layout column align-center">
                <!-- link one -->
                <div class="layout row">
                    <a
                        class="form__link indigo_5--text text-xs-center mb-1"
                        v-on:click="showRecoveryForm"
                        >Забыли пароль?</a
                    >
                </div>

                <!-- link two -->
                <a
                    class="form__link indigo_5--text text-xs-center"
                    href="//vk.com/club128349623"
                    target="blank"
                    rel="noopener"
                    >У меня нет аккаунта</a
                >
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import user from '@/api/user';
import router from '@/router';
import { bus } from '@/main';

export default {
    name: 'signinForm',

    data: () => ({
        signinLogin: null,
        signinPassword: null,
        showPassword: false,
        errorLogin: '',
        errorPassword: '',
        rules: {
            required: (value) => !!value || 'Это обязательное поле',
        },
    }),

    methods: {
        validate: function () {
            if (!this.$refs.signinForm.validate()) {
                return;
            }
            const data = {
                phone: '7' + this.signinLogin,
                password: this.signinPassword,
            };
            user.signin(data)
                .then((response) => {
                    localStorage.setItem('user', JSON.stringify(response.body));
                })
                .then(() => {
                    router.push('/dispatcher');
                })
                .catch((error) => {
                    let msg;

                    switch (error.body.error) {
                        case 'password or phone wrong': {
                            msg = 'Неверный логин/пароль';
                            break;
                        }
                        default: {
                            msg = 'Неизвестная ошибка';
                        }
                    }

                    bus.$emit('onError', msg);
                });
        },

        showRecoveryForm() {
            this.$emit('show');
            this.showTooltip = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';

.entrance__tooltip {
    color: $indigo_1;
}

.v-text-field__prefix {
}
</style>
